module.exports = __webpack_public_path__ + "img/uploader-default.73034e19.svg";